import React from 'react';
import styled from 'styled-components';
import { breakpoints, SC } from '../../../styles/theme';
import { MyAccountControllerTemplate } from './MyAccountControllerTemplate';
import { rem } from 'polished';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../../constants/main';
import { StylesOV } from './Styles.OV';
import { StylesOVGB } from './Styles.OVGB';
import { StylesDS } from './Styles.DS';
import { StylesAP } from './Styles.AP';
import { StylesAC } from './Styles.AC';

export interface IMyAccountControllerProps extends SC {
    title?: string;
}

export const MyAccountController = styled(MyAccountControllerTemplate)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: ${rem('500px')};
    margin: 0 auto;
    flex: 1 0 auto;
    .my-account-topnavbar {
        width: 100%;
    }
    .my-account-page {
        display: flex;
        flex-direction: row;
        width: 100vw;

        max-width: ${rem(1400)};
        margin: 0 auto;

        .my-account-content {
            display: flex;
            justify-content: space-between;
            width: 100%;

            min-height: ${rem('200px')};
            @media (min-width: ${breakpoints.sm}px) {
                padding-right: ${rem('10px')};
            }

            @media (min-width: ${breakpoints.lg}px) {
                width: 100%;
                max-width: ${rem(1000)};
            }

            .my-account-spinner {
                width: 100%;
                display: flex;
                justify-content: center;
                flex: 1 0 auto;
            }

            .nothing-found {
                width: 100%;
                display: flex;
                justify-content: center;
                height: 60%;
                align-items: center;
                h1 {
                    font-size: ${rem('20px')};
                    text-align: center;
                }
            }
        }

        .my-account-menu {
            white-space: nowrap;
            display: none;
            @media (min-width: ${breakpoints.md}px) {
                display: flex;
                flex-direction: row;
            }
        }
    }

    .my-account-box {
        display: flex;
    }
    .my-account-page {
        justify-content: center;

        @media (min-width: ${breakpoints.md}px) {
            flex-direction: row;
        }

        .my-account-controller {
            display: flex;
            flex-direction: column-reverse;

            @media (min-width: ${breakpoints.md}px) {
                flex-direction: row;
            }
        }

        .my-account-content {
            display: flex;
            flex-direction: column;

            @media (max-width: ${breakpoints.xs}px) {
                width: 100%;
            }

            &-title {
                display: none;
                font-weight: bold;
                font-size: ${rem('32px')};
                line-height: ${rem('38px')};
                text-transform: uppercase;
                color: black;
                margin: ${rem('24px')} 0 ${rem('8px')} 0;
                @media (min-width: ${breakpoints.sm}px) {
                    display: initial;
                    margin-bottom: ${rem('20px')};
                }
            }

            .my-account-deals {
                display: flex;
                flex-direction: column;
                width: 100%;
            }

            .my-account-home {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding-top: ${rem('10px')};

                @media (min-width: ${breakpoints.sm}px) {
                    flex-direction: row;
                }

                .imgbtn,
                .sectionPlaceholder {
                    height: ${rem('210px')};
                    width: 100%;

                    @media (min-width: ${breakpoints.xs}px) {
                        width: ${rem('404px')};
                    }

                    &:nth-of-type(even) {
                        @media (min-width: ${breakpoints.lg}px) {
                            margin-left: ${rem(20)};
                        }
                    }
                }
            }
        }
    }

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && (isMarketGB ? StylesOVGB : StylesOV)};
`;
